import { Icon } from "../../../../core/icon";
import { BRUSH_SIZE_SLIDER_ID } from "../ui-panes/BrushSizePane";
import { brushLikeOnClick, brushLikeOnDrag, brushLikeOnDragEnd, brushlikeOnHover } from "./_common";
export const EraseToolID = 'erase';
const changeLabel = 'Erase Hexes';
export const createEraseTool = (props) => {
    const [_, _2, removeFromHexModel] = props.hexMapModelContext;
    return {
        id: EraseToolID,
        label: 'Erase',
        icon: Icon.TOOL_ERASE,
        disablePan: true,
        usesToolOptions: {
            [BRUSH_SIZE_SLIDER_ID]: true,
        },
        onClick: brushLikeOnClick(props, (hexes) => removeFromHexModel(changeLabel, hexes)),
        onDrag: brushLikeOnDrag(props),
        onDragEnd: brushLikeOnDragEnd(props, (hexes) => removeFromHexModel(changeLabel, hexes)),
        onHover: brushlikeOnHover(props),
    };
};
createEraseTool.toolID = EraseToolID;
//# sourceMappingURL=eraseTool.js.map